<template>
  <div class="screenContainer fullscreen-wrapper">
    <div v-if="page.background !== ''" class="gameBackground" :style="{ backgroundImage: 'url(' + page.background + ')' }"></div>
    <div class="gameHeaderBar">
      <img class="gameHeaderBarLogo" src="/img/logo_grand.png" />
      <span class="gameHeaderBarTitle">{{ page.title }}</span>
    </div>
    <div class="gameHeaderSubBar">
      <span class="gameHeaderBarScore">Score : {{ score }}</span>
    </div>
    <loader class="mt-5" v-if="waitingBtob && scenarioType === 'btob'"></loader>
    <div v-else class="gameContent">
      <game-content :page="page" :gameStep="gameStep" @refresh="refresh" @next="next">
        <template #action-bar>
          <game-action-bar :page="page" :gameStep="gameStep" @refresh="refresh" @next="next"/>
        </template>
        <template #timer>
          <v-row no-gutters justify="center">
            <flip-countdown v-if="deadline" :deadline="deadline" :showDays="false" :showHours="false" @timeElapsed="refresh('timer-end')"></flip-countdown>
          </v-row>
        </template>
      </game-content>
    </div>
    <notifications group="game" position="top center" />
    <v-icon v-if="!isFullscreen" class="gameIconFullScreen" x-large @click="toogleFullScreen">mdi-fullscreen</v-icon>
    <v-icon v-if="isFullscreen" class="gameIconFullScreen" x-large @click="toogleFullScreen">mdi-fullscreen-exit</v-icon>
    <div class="text-center">
      <v-dialog v-model="firstVisit" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Experience Sapio
          </v-card-title>
          <v-card-text class="pt-6">
            Vous aller reprendre l'expérience la ou vous l'avez laisser.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="firstVisit = false">
              Valider
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-progress-linear v-if="page && page.audio !== ''" class="progressBar" :value="audioProgress"></v-progress-linear>
  </div>
</template>

<script>
  import axios from 'axios'
  import { api as fullscreen } from 'vue-fullscreen'
  import moment from 'moment'
  import GameActionBar from '../components/GameActionBar.vue'
  import GameContent from '../components/GameContent.vue'
  import FlipCountdown from 'vue2-flip-countdown'
  import {P2P} from '../plugins/p2p.js'
  import Loader from '../components/Loader.vue'

  /**
   * @brief Game view managing user game progress (btob/btoc).
   * @bug No known bugs.
   */
  export default {
    name: "Game",
    components: {GameActionBar, GameContent, FlipCountdown, Loader},
    data: () => ({
      page: {},
      gameStep: {},
      isFullscreen: false,
      audio: null,
      audioProgress: 0,
      score: 0,
      firstVisit: false,
      p2p: null,
      waitingBtob: true,
      timeout: null
    }),
    computed: {
      deadline: function () {
        return this.gameStep && this.gameStep.maxTime ? moment().add(this.gameStep.maxTime, 'second').format('YYYY-MM-DD HH:mm:ss') : undefined
      },
      scenarioType: function () {
        return SAPIO.Scenario.instance.type
      }
    },
    watch: {
      'game.status': function () {
        this.page = SAPIO.Owner.instance.getPage()
        this.gameStep = SAPIO.Game.instance.gameStep
      },
      page: {
        handler (oldValue, newValue) {
          clearTimeout(this.timeout)
          if (oldValue) this.playBackgroundAudio(oldValue.audio)
          if (oldValue.nextOption.type === "AFTERTIME") {
            this.timeout = setTimeout(() => {
              this.gameStep.hintIndex < this.gameStep.nbHints || [3, 5].includes(this.gameStep.subStatus) ? this.next('subStep') : this.next('step')
            }, parseInt(this.page.nextOption.data, 10) * 1000)
          }
        },
        deep: true
      },
      firstVisit: function () {
        if(this.page) this.playBackgroundAudio(this.page.audio)
      }
    },
    created() {
      SAPIO.Game.LS_EMPTY()
      SAPIO.Scenario.LS_EMPTY()
      SAPIO.Team.LS_EMPTY()
      SAPIO.Loader.instance.loadScenario(this.$route.params.scenarioId).then((response) => {
        var json = {...JSON.parse(response.json_data), ...response}
        delete json.json_data
        SAPIO.Scenario.createFromJson(json)
        SAPIO.Scenario.instance.LS_SAVE()
        SAPIO.Game.createFromJson({scenario_id: json.id, status:0, teamId: 0, currentStepIndex: -1, teamStates: {0: []}})
        SAPIO.Game.instance.goToNextStep(parseInt(this.$route.params.stepId))
        SAPIO.Game.instance.LS_SAVE()
        this.startGame();
      }).catch((e) => {
        this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du chargement du scenario', text: e.message })
        console.error(e)
      })
    },
    methods: {
      playBackgroundAudio(audioUrl) {
        if (this.audio && this.audio.pause) this.audio.pause();
        if (!this.firstVisit && audioUrl !== "") {
          this.audio = new Audio(audioUrl)
          this.audioProgress = 0
          this.audio.addEventListener("canplaythrough", event => {
            this.audio.play();
          });
          this.audio.addEventListener("timeupdate", event => {
            this.audioProgress = (this.audio.currentTime / this.audio.duration) * 100
          });
          if (this.page.nextOption.type === "AUDIOENDED") {
            this.audio.addEventListener("ended", event => {
              if (this.gameStep.subStatus !== 3)
                this.gameStep.hintIndex < this.gameStep.nbHints || [3, 5].includes(this.gameStep.subStatus) ? this.next('subStep') : this.next('step')
            });
          }
        }
      },
      toogleFullScreen() {
        fullscreen.toggle(this.$el.querySelector('.fullscreen-wrapper'), {
          callback: (isFullscreen) => this.isFullscreen = isFullscreen
        })
      },
      refresh(type = '') { 
        this.gameStep = SAPIO.Game.instance.gameStep;
        if (type === 'subStep') this.gameStep.showHint();
        if (type === 'timer-end' && this.gameStep.type === "guess" && this.gameStep.subStatus !== 3) this.gameStep.showLost();
        if (type === 'info') this.gameStep.showExtraInfo();
        if (type === 'aop') this.gameStep.step.maxTime = 0;
        this.gameStep = SAPIO.Game.instance.gameStep;
        this.page = SAPIO.Game.instance.page;
        this.score = SAPIO.Game.instance.score;
        this.updateGameOnSever();
      },
      startGame() {
        this.waitingBtob = false
        let startStepIndex = SAPIO.Game.instance.currentStepIndex
        const sp = window.location.href.split('=')
        if (sp.length > 0) {
          const debugStepIndex = parseInt(sp[1])
          if (!isNaN(debugStepIndex) && debugStepIndex > -1) startStepIndex = debugStepIndex
        } else startStepIndex = SAPIO.Game.instance.currentStepIndex
        this.next('step', startStepIndex)
        this.refresh();
      },
      updateGameOnSever() {
        if (SAPIO.Scenario.instance.type === "btoc") {
          if (SAPIO.User.instance) axios.post(process.env.VUE_APP_SERVER_URL + '/api/updateGame', {
            api_key: SAPIO.User.instance.api_key,
            game_id: SAPIO.Game.instance.id,
            status: SAPIO.Game.instance.status,
            json_data: JSON.stringify(SAPIO.Game.instance.getJSON())
          }).then(response => {
            console.log("Saved Game state");
          }).catch(e => {
            console.log("Saved Game state error " + e);
          });
        } else {
          this.p2p.sendMessage({to: "master", from: "client", eventName: "update-team-state", data: SAPIO.Game.instance.getJSON()})
        }
      },
      next(type, stepIndex = -1) {  
        if (type === "step") {
          if (SAPIO.Game.instance.currentStepIndex >= SAPIO.Scenario.instance.steps.length - 1) this.$router.push('/ranking')
          else SAPIO.Game.instance.goToNextStep(stepIndex)
          if (!this.firstVisit) SAPIO.Game.instance.LS_SAVE();
          this.refresh()
        } else if (type === 'subStep') {
          this.refresh(type)
        }
      }
    },
  }
</script>

<style scoped>
  .screenContainer {
    width: 100%;
    height: 100%;
    color: #444343;
    line-height: 0.9;
    font-family: 'Roboto', sans-serif;
    overflow: hidden;
  }

  .gameHeaderBar {
    background-color: rgba(255, 255, 255, 0.9);
    height: 60px;
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
  }

  .gameHeaderSubBar {
    background-color: rgba(255, 255, 255, 0.9);
    height: 40px;
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 6px 10px 0 rgba(0,0,0,.12);
  }

  .gameContent {
    position: relative;
    height: calc(100% - 100px);
    font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));
  }

  .gameContentMain {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: unset;
  }

  .gameBackground {
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .gameHeaderBarLogo { 
    position: absolute;   
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    margin-left: 20px;
  }

  .gameHeaderBarScore {
    position: absolute;
    left:50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 160%;
    font-weight: bold;
  }

  .gameHeaderBarTitle {
    position: absolute;   
    top: 50%;
    transform: translateY(-50%);
    margin-right: 20px;
    right: 0;
    font-size: 160%;
    font-weight: bold;
  }

  .gameIconFullScreen {
    position: fixed;
    bottom: 10px;
    right: 10px;
    cursor: pointer;
    color: #444343;
  }

  .gameIconFullScreen:after {
    background-color: unset;
  }

  .progressBar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  #countdown {
    position: relative;
    margin: auto;
    margin-top: 100px;
    height: 40px;
    width: 40px;
    text-align: center;
  }

  #countdown-number {
    color: #333;
    display: inline-block;
    line-height: 40px;
  }

  svg {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    transform: rotateY(-180deg) rotateZ(-90deg);
  }

  svg circle {
    stroke-dasharray: 113px;
    stroke-dashoffset: 0px;
    stroke-linecap: round;
    stroke-width: 2px;
    stroke: #333;
    fill: none;
  }

  @keyframes countdown {
    from {
      stroke-dashoffset: 0px;
    }
    to {
      stroke-dashoffset: 113px;
    }
  }

  .gameContent >>> .flip-card__top, .gameContent >>> .flip-card__bottom, .gameContent >>> .flip-card__bottom::after, 
  .gameContent >>> .flip-card__back, .gameContent >>> .flip-card__back::before, 
  .gameContent >>> .flip-card__back-bottom, .gameContent >>> .flip-card__back-bottom::after {
    color: #FFF;
  }
</style>